module.exports = __webpack_public_path__ + "img/error-img.6856dce3.png";